import moment from "moment";

export function numberSorter(a: any, b: any, attribute: string) {
  return a[attribute] - b[attribute];
}

export function stringSorter(a: any, b: any, attribute: string) {
  const aCompare = a[attribute] ?? "";
  const bCompare = b[attribute] ?? "";
  return aCompare.localeCompare(bCompare);
}

export function stringDateSorter(a: any, b: any, attribute: string) {
  return moment(a[attribute]).valueOf() - moment(b[attribute]).valueOf();
}
